import React from 'react';

export const TitleUser = ({ record }: any) => (
    <div>{`${record.firstName} ${record.lastName}`}</div>
);